exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-simple-controls[data-v-592d4412]{width:155px}", ""]);

// exports
